<template>
    <div>
        <eqt-table @refresh="refresh"
                   :total="total"
                   :loading="loading"
                   :title="$t('Pages.ScheduledOvertimes.attending_users')"
                   :items="items"
                   :headers="headers"
                   hide-search
                   hide-pagination
                   :hide-actions="true">
            <template slot="items" slot-scope="{ item }">
                <td>{{ item.id }}</td>
                <td>{{item.profile.name}}</td>
                <td>{{ item.sectors && item.sectors.length > [0] ? item.sectors[0].name : $t('Common.not_assigned')}}</td>
                <td class="text-xs-right" v-if="!hideActions">
                    <v-tooltip top>
                        <v-btn slot="activator" class="mx-0" small flat icon color="error" @click="remove(item.id)">
                            <v-icon  small>delete</v-icon>
                        </v-btn>
                        <span>{{$t('Core.Fields.delete')}}</span>
                    </v-tooltip>
                </td>
            </template>
        </eqt-table>
    </div>
</template>

<script>
    import i18n from '@/i18n'
    import EqtTable from '../../components/core/Table'
    export default {
        name: "attending-users-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            overtime: {
              type: Object,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                required: true
            },
            hideActions: {
                type: Boolean,
                default: false
            },

        },
        data: () => ({
            headers: [
                {
                    sortable: false,
                    text: '#',
                    value: 'id'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Users.model.name'),
                    value: 'profile.name'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Sectors.title_singular'),
                    value: 'sector.name'
                },
            ],
            dialog: false,
            selectedItem: {pivot:{}}
        }),
        computed:{

        },
        created(){
          if(!this.hideActions){
            this.headers.push({
              sortable: false,
              text: i18n.t('Core.Fields.actions'),
              value: 'actions',
              align: 'right'
            });
          }
        },
        methods: {
            refresh(data){
                this.$emit('refresh', data);
            },
            attended(item){
              this.selectedItem = item;
              this.dialog = true;
            },
            onUpdate(item){
                this.$emit('update', item);
            },
            remove(id){
                this.$emit('delete', id);
            },
            onClose(){
              this.dialog = false;
              this.selectedItem = {pivot: {}};
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
